import { AgencyId } from "@inrev/common";
import { useAdminFetchAgencyPreviews } from "@portal/api/agency/admin";
import { FC, useMemo } from "react";
import { DropdownInput } from "./DropdownInput";

export type AgencySelectorInputProps = {
	value: AgencyId | null;
	onChange: (value: AgencyId | null) => void;
	excludeAgencyId?: AgencyId;
	testId?: string;
	disabled?: boolean;
	readonly?: boolean;
	compact?: boolean;
	error?: boolean;
	placeholder?: string;
	optionsClassName?: string;
};

export const AgencySelectorInput: FC<AgencySelectorInputProps> = ({
	value,
	onChange,
	excludeAgencyId,
	testId = "agency-selector-dropdown",
	disabled,
	readonly,
	compact,
	error,
	placeholder,
	optionsClassName,
}) => {
	const { agencyPreviews, agencyPreviewsLoading } = useAdminFetchAgencyPreviews();

	const agencyOptions = useMemo(
		() =>
			(agencyPreviews ?? [])
				.filter((agency) => agency.id !== excludeAgencyId)
				.map((agency) => ({ value: agency.id, label: agency.displayName })),
		[agencyPreviews, excludeAgencyId],
	);

	return (
		<DropdownInput
			testId={testId}
			value={value ?? undefined}
			placeholder={placeholder ?? (agencyPreviewsLoading ? "Loading agencies…" : "Select agency")}
			disabled={disabled}
			readonly={readonly}
			compact={compact}
			error={error}
			options={agencyOptions}
			onChange={onChange}
			optionsClassName={optionsClassName}
		/>
	);
};
